import React, { useRef, useEffect } from 'react';
import styled, { css } from 'styled-components';
import { BaseLink } from 'components/Link';
import { GiEvilBat } from 'react-icons/gi';
import button from 'art/button.png';
import button_selected from 'art/button_selected.png';
import back_button from 'art/back_button.png';

const backButtonStyles = css`
  width: 10vw;
  height: 10vw;
  &:focus {
    filter: brightness(85%);
  }
  position: fixed;
  top: 0;
  left: 3vw;
`;

const waitingRoomsStyles = css`
  top: 50.7vw;
  left: 79vw;
  width: 2vw;
  height: 3vw;
  transform: rotate(-11deg);
  font-size: 1vw;
`;

const Bat = styled(GiEvilBat)`
  font-size: 2rem;
  position: absolute;
  left: -40px;
  display: ${({ selected }) => (selected ? 'inline' : 'none')};
`;
const StyledLink = styled(BaseLink)`
  display: flex;
  align-items: center;
  background-image: url(${({ $selected, $backButton }) => {
    if ($backButton) {
      return back_button;
    }
    return $selected ? button_selected : button;
  }});
  background-size: 100% 100%;
  &:focus {
    background-image: url(${({ $backButton }) => ($backButton ? back_button : button_selected)});
  }
  &:focus > ${Bat} {
    'display: inline;'
  }
  ${(props) => props.$backButton && backButtonStyles}
  ${(props) => props.$waitingRoom && waitingRoomsStyles}
`;

const SelectableLink = ({ children, selected, backButton, waitingRoom, ...rest }) => {
  const linkRef = useRef(null);
  const handleOnMouseOver = () => {
    linkRef.current.focus();
  };
  useEffect(() => {
    if (selected) {
      linkRef.current.focus();
    } else {
      linkRef.current.blur();
    }
  }, [selected, linkRef]);
  return (
    <StyledLink
      ref={linkRef}
      onMouseOver={handleOnMouseOver}
      $selected={selected}
      as={rest.to ? '' : 'a'}
      role={rest.to ? '' : 'button'}
      tabIndex={0}
      $backButton={backButton}
      $waitingRoom={waitingRoom}
      {...rest}
    >
      <Bat selected={selected} />
      {children}
    </StyledLink>
  );
};

export default SelectableLink;
